import React from 'react';
import './projects.css'; 

// Import your images here
import shopMonogramImage from '../../assets/monogram.png';
import newsHomepageImage from '../../assets/news.png'; 
import calculatorImage from '../../assets/calc.png';
import sqwadsImage from '../../assets/sqwads.png';
import safwahImage from '../../assets/safwah-img.png';
import titiImage from '../../assets/titi-img.png';
import contractorImage from '../../assets/contractor-img.png';
import tbiImage from '../../assets/tbi.png';
import apexImage from '../../assets/apex.png';

const projectsData = [
     {
    id: 4,
    title: "Sqwads Comp.",
    description: "A fully functional public websites to brigde the gap between learning and doing",
    role: "Frontend Developer: Led the development of the entire user interface using Next.js, TypeScript, and Tailwind CSS, ensuring a responsive, high-performance, and type-safe application.",
    image: sqwadsImage, 
    liveUrl: "https://sqwads.com/",
    githubUrl: "",
    technologies: ["React", "CSS3", "JavaScript", "Responsive Design"]
  },
     {
    id: 6,
    title: "The Blessed Institute",
    description: "A fully functional public website bridging the gap between learning and doing — a complete online Islamic education platform with course enrollment, admin management, and cloud-based media storage.",
    role: "Full-Stack Developer: Led development of the entire platform using React, TypeScript, and Tailwind CSS on the frontend, with a Supabase backend and Cloudflare Workers/R2 for serverless image handling, ensuring a responsive, high-performance, and type-safe application.",
    image: tbiImage,
    liveUrl: "https://theblessedinstitute.com/",
    githubUrl: "",
    technologies: ["React", "TypeScript", "Tailwind CSS", "Supabase", "Cloudflare Workers"]
  },
     {
    id: 7,
    title: "Apexsky Nigeria",
    description: "A full-featured corporate platform for a real estate and multi-division business, with a custom admin dashboard, Supabase-backed content management, and WhatsApp-integrated inquiry flows.",
    role: "Full-Stack Developer: Built the complete platform end-to-end — React/TypeScript frontend with Tailwind CSS, Supabase backend (schema, auth, storage), and a custom admin CMS for managing listings, inquiries, and multi-division content. Deployed on Cloudflare Workers.",
    image: apexImage,
    liveUrl: "https://apexskynigeria.com/",
    githubUrl: "",
    technologies: ["React", "TypeScript", "Tailwind CSS", "Supabase", "Cloudflare Workers"]
  },
     {
  id: 5,
  title: "Safwah Brand – Premium Streetwear E-Commerce",
  description: "A premium Arabic calligraphy streetwear e-commerce platform with a modern shopping experience, product catalog, and WhatsApp-integrated checkout built for the Nigerian market.",
  role: "Full-Stack Developer: Designed and developed the entire platform using React, Supabase for backend and database, and deployed on Cloudflare Workers for edge performance.",
  image: safwahImage,
  liveUrl: "https://safwah-clothing.imranolonamustopha.workers.dev/",
  githubUrl: "",
  technologies: ["React", "Supabase", "Cloudflare Workers", "TypeScript", "Tailwind CSS"]
},
{
  id: 6,
  title: "Abu Woodworks – Timber & Wood Products Store",
  description: "A business e-commerce website for a timber and wood products company, featuring a product catalog and WhatsApp-integrated order flow designed for Nigerian buyers.",
  role: "Full-Stack Developer: Built the full frontend and backend integration using React, Supabase, and Cloudflare Workers, with a WhatsApp checkout pattern tailored for local business operations.",
  image: contractorImage,
  liveUrl: "https://abu-woodworks.imranolonamustopha.workers.dev/",
  githubUrl: "",
  technologies: ["React", "Supabase", "Cloudflare Workers", "TypeScript", "Tailwind CSS"]
},
{
  id: 7,
  title: "Titilope Agro – Garri Retail & Wholesale Platform",
  description: "An e-commerce platform for a Nigerian garri retail and wholesale business, enabling customers to browse products and place orders seamlessly via WhatsApp integration.",
  role: "Full-Stack Developer: Developed the complete storefront and Supabase backend, deployed on Cloudflare Workers, with a WhatsApp-driven checkout experience optimized for Nigerian consumers.",
  image: titiImage,
  liveUrl: "https://titilope-agro.imranolonamustopha.workers.dev/",
  githubUrl: "",
  technologies: ["React", "Supabase", "Cloudflare Workers", "TypeScript", "Tailwind CSS"]
},
  {
    id: 1,
    title: "Shop Monogram",
    description: "A visually engaging and responsive landing page that highlights the potential of Web 3.0, using modern design trends to present content in an aesthetically pleasing manner.",
    role: "Frontend Developer (UI/UX Implementation ): Cloned the official Monogram website interface, meticulously recreating the design and user experience using React, JavaScript, and CSS for pixel-perfect fidelity.",
    image: shopMonogramImage, 
    liveUrl: "https://monogram-web-page.vercel.app/",
    githubUrl: "https://github.com/Khoiriyah23/monogram-web-page.git",
    technologies: ["React", "CSS3", "JavaScript", "Responsive Design"]
  },
  {
    id: 2,
    title: "News Homepage",
    description: "A sleek and organized web layout designed for news and trending topics, featuring modular grid sections and interactive elements with responsive design principles.",
    role: "Frontend Developer: Developed a clean, responsive, and modular web layout for a news homepage using React and CSS, focusing on optimal structure and presentation of content.",
    image: newsHomepageImage, 
    liveUrl: "https://techversifier-newshomepage.vercel.app",
    githubUrl: "https://github.com/Khoiriyah23/News-homepage.git",
    technologies: ["Node.js", "MongoDB", "Express", "Responsive Design"]
  },
  {
    id: 3,
    title: "Calculator Javascript",
    description: "A fully functional calculator application built with vanilla JavaScript, featuring a clean interface and comprehensive mathematical operations.",
    role: "Frontend Developer (JavaScript Focus ): Engineered a fully functional calculator application using Vanilla JavaScript, demonstrating strong command over core language features and DOM manipulation for a clean, interactive user experience.",
    image: calculatorImage, 
    liveUrl: "https://calculator-proj-three.vercel.app",
    githubUrl: "https://calculator-proj-three.vercel.app/",
    technologies: ["JavaScript", "HTML5", "CSS3", "DOM Manipulation"]
  },
 
];



const Projects = (  ) => {
  return (
    <section className="projects section" id="projects">
      <h2 className="section__title">My Projects</h2>
      <span className="section__subtitle">What I have built</span>

      <div className="projects__container container grid">
        {projectsData.map((project) => (
          <div key={project.id} className="projects__card">
            <a 
              href={project.liveUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="projects__link"
            >
              <div className="projects__image-container">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="projects__image"
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDQwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xNzUgNzVIMjI1VjEyNUgxNzVWNzVaIiBmaWxsPSIjOUI5QkEwIi8+CjxwYXRoIGQ9Ik0xOTAgMTAwTDIwNSA4NUwyMTAgMTAwTDE5NSAxMTVMMTkwIDEwMFoiIGZpbGw9IiNGRkZGRkYiLz4KPC9zdmc+';
                  }}
                />
                <div className="projects__overlay">
                  <span className="projects__view-text">View Project</span>
                </div>
              </div>
              <div className="projects__info">
                <h3 className="projects__title">{project.title}</h3>
                <p className="projects__description">{project.description}</p>
                <p className="projects__role">
                  <strong>My Role:</strong> {project.role}
                </p>
                <div className="projects__tech-stack">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="projects__tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </a>
            <div className="projects__actions">
              <a 
                href={project.liveUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="projects__btn projects__btn-primary"
              >
                <i className="uil uil-external-link-alt"></i>
                Live Demo
              </a>
              <a 
                href={project.githubUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="projects__btn projects__btn-secondary"
              >
                <i className="uil uil-github-alt"></i>
                Source Code
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
